import createDataContext from "./createDataContext";

const themeReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "set_dark_mode":
      return { ...state, darkMode: payload };
    default:
      return state;
  }
};

const checkLocalTheme = dispatch => () => {
  const darkThemeLocalStorage =
    localStorage.getItem("themeSwitch") !== null &&
    localStorage.getItem("themeSwitch") === "dark";
  dispatch({ type: "set_dark_mode", payload: darkThemeLocalStorage });
};

const setDarkMode = dispatch => async darkMode => {
  dispatch({ type: "set_dark_mode", payload: darkMode });
  if (darkMode) {
    document.body.setAttribute("data-theme", "dark");
    localStorage.setItem("themeSwitch", "dark");
  } else {
    document.body.removeAttribute("data-theme");
    localStorage.removeItem("themeSwitch");
  }
};

export const { Provider, Context } = createDataContext(
  themeReducer,
  {
    setDarkMode,
    checkLocalTheme
  },
  { darkMode: false }
);
